import { IsBoolean, IsDateString, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CreateCleaningRecordDto {
  @IsDateString()
  date!: string;

  @IsBoolean()
  @IsOptional()
  isCompliant?: boolean;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  nonComplianceReason?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  signatureStorageKey?: string;
}
